import {
  Component,
  Injector,
  OnInit,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { ControllerService } from 'src/app/services/controller.service';
import { ModalService } from 'src/app/services/modal.service';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { CommonService } from 'src/app/services/common/common.service';
import { EmqxRecieveMessageModel } from 'src/app/models/common/emqx-receive-message.model';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteConstants } from 'src/app/constants/route-constants';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent implements OnInit {
  elem: any;
  isFullscreen: any = false;
  crypto = window.crypto || window.Crypto;
  array = new Uint32Array(1);
  filterObject = new InstallerDashboardUsersPipe();
  intervalSubscription: any;
  controller_specific_info: any;
  critical_user: any = [];
  normal_user: any = [];
  user_details: any = [];
  fullname: any;
  profile_image: any;
  user_email: any;
  timezone: any;
  user_id: any;
  files_id: any;
  controller_status: any;
  cloud_base_url: string = environment.cloud_base_url;
  _is_api_calling: boolean = false;
  _stream_called: boolean = false;
  _stream_telemetry_called: boolean = false;
  _stream_qr_called: boolean = false;
  info_user: any = [];
  telemetry_data: any;
  searchTerm: string = '';
  currentPage = 1;
  itemsPerPage = 9;
  alert_list: any = [];
  controllerStatus:string = ""
  userId:string = ""
  click = false
  isAdmin:boolean = false
    constructor(
    private controller: ControllerService,
    private auth: AuthserviceService,
    private _modalService: ModalService,
    config: NgbModalConfig,
    // private _mqttService: MqttService,
    private storage: StorageService,
    private commonService: CommonService,
    private router: Router,
     private route: ActivatedRoute,
    private injector: Injector
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }
  // private curSubscription: Subscription | undefined;
  private imageSubscription: Subscription | undefined;
 
  ngOnInit(): void {
        AppSessionStorageService.sideBarSelection = 1
        this.route.queryParams.subscribe(params => {
          this.userId = params["user_id"]
          const decryptedUserId = this.userId ? this.auth.decryptParams(this.userId) : ""

          this.setGrantAccessToken(decryptedUserId)
          
         
        }) // Decrypt use id to resolve the browser back navigation issur
  
          }
 
  async dasboardSwitchOnRefresh() {
    if( AppSessionStorageService.auth?.role == 'administrator'){
      this.isAdmin = true
    }
    if (
      !AppSessionStorageService.grantAccess &&
      AppSessionStorageService.auth?.role == 'administrator'
    ) {
      this.backToAdminDashboard();
      }
    return null;
  }

  async setGrantAccessToken(userId?:string){
    if (userId){
    const response = await this.controller.customerAdminAccess({"user_id":userId});
 
    if (response?.success && response.data) {
      const sessionService = this.injector.get(AppSessionStorageService)
      sessionService?.setGrantToken(response.data, true);
    }}
    this.dasboardSwitchOnRefresh();
    this.adminInstallerView();
   
    this.getUserSpecificInfo();
    this.get_controller_specific_telemetry();
    this.get_controller_specific_status();
    this.get_controller_specific_qr_code();
    this.listenMqttMessages();
  }
 
  adminInstallerView() {
    if (
      !AppSessionStorageService.grantAccess?.access_token &&
      AppSessionStorageService.auth?.role == 'installer'
    ) {
      this.imageSubscription = this.auth.userProfileDetails$.subscribe(
        (response) => {
          this.userDetails();
        }
      );
      if (!this.profile_image) {
        this.profile_image = 'assets/default-image.svg';
      }
    } else {
      const installer_details = AppSessionStorageService.installeView;
      this.setUserDetails(installer_details);
    }
  }
 
  setUserDetails(installer_details: any) {
    this.fullname =
      installer_details?.firstname + ' ' + installer_details?.lastname;
    this.user_email = installer_details?.username;
    this.timezone = installer_details?.timezone;
    this.files_id = installer_details?.files_id;
    this.profile_image = this.auth.getInstallerImages(this.files_id);
    this.user_id = installer_details?.user_id;
  }
 
  userDetails() {
    const user_details = this.auth.getUserDetails();
    if (user_details) {
      this.fullname = user_details.firstname + ' ' + user_details.lastname;
      this.user_email = user_details.username;
      this.timezone = user_details.timezone;
      this.profile_image = this.auth.getUserImage();
      this.user_id = user_details.user_id;
      this.files_id = user_details.files_id;
    }
  }
 
  sessionSelector() {
    if (AppSessionStorageService.grantAccess) {
      return false;
    }
    return true;
  }
 
  get_controller_state(controller_status:string){
    if(controller_status == "Active"){
      return "Commissioned"
    }
    return "Decommissioned"
 
  }
 
  profileView(){
    if(!this.sessionSelector()){
      AppSessionStorageService.grantAccess = null
      this.router.navigate(['admin/profile']);
    }else{
      this.router.navigate(['installer/profile']);
    }
  }
 
  backToAdminDashboard() {
    AppSessionStorageService.grantAccess = null
    this.router.navigate(['admin'],{replaceUrl:true});
  }
 
  async get_controller_specific_status() {
    if (!this._stream_called) {
      this._stream_called = true;
      this.controller_status = await this.controller.get_controller_status();
      for (const record of this.controller_status) {
        this.storage.saveToLocalStorage(
          record.controller_uuid,
          record.controller_status
        );
      }
    }
    this._stream_called = false;
  }
 
 
async updateControllerStatus(controller_uuid:any,event?:any){
  
  if(event?.target.checked){
    this.controllerStatus = "Active"
 
  }
  else{
    this.controllerStatus = "Inactive"
  }
  const controllerInfo = await this.controller.controllerPatch({"controller_status":this.controllerStatus,"controller_uuid":controller_uuid});
 
 
 
}
 
  async get_controller_specific_qr_code() {
    if (!this._stream_qr_called) {
      this._stream_qr_called = true;
      this.controller_status =
        await this.controller.get_controller_qr_content();
      for (const record of this.controller_status) {
        this.storage.saveToLocalStorage(
          record.controller_uuid + '_qr',
          record.qr_content
        );
      }
      this._stream_qr_called = false;
    }
  }
  async get_controller_specific_telemetry() {
    if (!this._stream_telemetry_called) {
      this._stream_telemetry_called = true;
      this.telemetry_data = await this.controller.get_controller_telemetry();
      for (const record of this.telemetry_data) {
        if (record._field == 'ph' || record._field == 'set_ph') {
          this.storage.saveToLocalStorage(
            record.controller_uuid + '_' + record._field,
            parseFloat(record._value).toFixed(2)
          );
        } else {
          this.storage.saveToLocalStorage(
            record.controller_uuid + '_' + record._field,
            parseFloat(record._value).toFixed(1)
          );
        }
      }
    }
    this._stream_telemetry_called = false;
  }
 
  async getUserSpecificInfo() {
    if (!this._is_api_calling) {
      this._is_api_calling = true;
      const controllerInfo = await this.controller.getInstallerUserInfo();
                  this.controller_specific_info = this.filterObject.transform(
        controllerInfo,
        this.searchTerm
      );
      this.critical_user = [];
      this.normal_user = [];
      this.info_user = [];
      this.UserSpecificInfoProcessor(this.controller_specific_info);
      this._is_api_calling = false;
    }
  }
 
  getImagePath(deviceId: string): string {
    // Define a mapping of device IDs to image paths
    const imageMap: { [key: string]: string } = {
      HeatPump: 'assets/img/heatpump.svg',
      SaltChlorinator: 'assets/img/alarm-salt-chlorinator.svg',
      DosingPump: 'assets/img/alarm-dosing-pump.svg',
      VsPump: 'assets/img/alarm-vs-pump.svg',
      UvLamp: 'assets/img/uv-light.svg',
      HeatPumpSg: 'assets/img/heatpump.svg'
      // Add more mappings as needed
    };
 
    // Check if the device ID exists in the mapping
    if (imageMap.hasOwnProperty(deviceId)) {
      return imageMap[deviceId];
    } else {
      // If device ID not found, return a default image path or handle it accordingly
      return 'assets/img/default-image.png';
    }
  }
 
  logout() {
    this.commonService.disconnectMqtt();
    if (this.isFullscreen) {
      this.fullscreen();
    }
    this.auth.logout();
  }
 
  get_controller_status(controller_uuid: any) {
    const status = this.storage.getFromLocalStorage(controller_uuid);
    if (status) {
      return status;
    } else {
      return 'offline';
    }
  }
 
  get_controller_telemetry(controller_uuid: any, field: any) {
    const sensor_value = this.storage.getFromLocalStorage(
      controller_uuid + '_' + field
    );
    if (sensor_value) {
      return sensor_value;
    } else {
      return 0;
    }
  }
 
  // for fetching temperature value
  get_temperatureValue(controller_uuid: string):any {
    return this.get_controller_telemetry(controller_uuid,
                                            "temperature"
                                          )
    }
 
  // for fetching orp value
  get_orpValue(controller_uuid: string):any {
    return this.get_controller_telemetry(controller_uuid,
                                            "orp"
                                          )
    }
 
  // for fetching ph value
  get_phValue(controller_uuid: string):any {
    return this.get_controller_telemetry(controller_uuid,
                                            "ph"
                                          )
    }
 
  // for fetching set_orp value
  get_setOrpValue(controller_uuid: string):any {
    return this.get_controller_telemetry(controller_uuid,
                                            "set_orp"
                                          )
    }
 
  // for fetching set_ph value
  get_setPhValue(controller_uuid: string):any {
    return this.get_controller_telemetry(controller_uuid,
                                            "set_ph"
                                          )
    }
 
  // for fetching ph_concentration value
  get_phConcentrationValue(controller_uuid: string):any {
    return this.get_controller_telemetry(controller_uuid,
                                            "ph_concentration"
                                          )
    }
    
 
 
  ngOnDestroy(): void {
    try {
      this.imageSubscription?.unsubscribe();
      // if user is admin that o destory topic should be installer id else it will take user id on logged in user
      if(AppSessionStorageService.auth?.role == 'administrator'){
      this.commonService.unSubscribeMqttTopic(AppSessionStorageService.installeView?.user_id??'')
      }else{
        this.commonService.unSubscribeMqttTopic(AppSessionStorageService.user?.user_id??'')
      }
    } catch (_) {}
  }
 
  openProfileView(): void {
    if (!AppSessionStorageService.installeView) {
      this._modalService.closeEditProfileDisplay();
      this._modalService.closeQrsDisplay();
      this._modalService.openProfileDisplay();
      this.storage.saveToLocalStorage('profile', 'open');
    }
  }
 
  qrOpenView(user_id: any, controller_uuid: any): void {
    this.storage.saveToLocalStorage('click_user_id', user_id);
    this.storage.saveToLocalStorage('clicked_user_' + user_id, controller_uuid);
    this._modalService.openQrDisplay();
    this._modalService.closeProfileDisplay();
  }
 
  getProfileOpenStatus() {
    const profile_view_status = this.storage.getFromLocalStorage('profile');
    if (profile_view_status == 'open') {
      return true;
    }
    return false;
  }
  UserSpecificInfoProcessor(controller_info: any) {
    if (controller_info.length > 0) {
      for (const record of controller_info) {
        if (record.controller_details.length > 0) {
          this.UserSpecificAlertProcessor(record);
        } else if (record.controller_details.length == 0) {
          this.normal_user.push(record);
          this.storage.saveToLocalStorage(
            record.controller_uuid + '_type',
            'normal'
          );
        }
      }
    }
    this.removeDuplicatesFromInfoUser();
    return true;
  }
 
  UserSpecificAlertProcessor(user_specific_record: any) {
    for (const alert_code of user_specific_record.controller_details) {
      for (const alert_type of alert_code.alerts) {
        this.alertArrayCreator(alert_type, user_specific_record);
      }
    }
    return true;
  }
 
  alertArrayCreator(
    alert_type: { alert_type: number },
    user_specific_record: { controller_uuid: string; controller_details: any }
  ) {
    if (alert_type.alert_type == 2) {
      // Check if the user_specific_record is already in the info_user
      const isInfoRecordExists = this.info_user.some(
        (record: any) =>
          record.controller_details === user_specific_record.controller_details
      );
      if (!isInfoRecordExists) {
        this.info_user.push(user_specific_record);
        const user_type_on_alarm = this.getUserType(
          user_specific_record.controller_uuid
        );
        if (user_type_on_alarm != 'critical') {
          this.storage.saveToLocalStorage(
            user_specific_record.controller_uuid + '_type',
            'info'
          );
        }
      }
    } else if (alert_type.alert_type == 1) {
      // Check if the user_specific_record is already in the critical_user array
      const isCriticalRecordExists = this.critical_user.some(
        (record: any) =>
          record.controller_details === user_specific_record.controller_details
      );
      if (!isCriticalRecordExists) {
        this.critical_user.push(user_specific_record);
        this.storage.saveToLocalStorage(
          user_specific_record.controller_uuid + '_type',
          'critical'
        );
      }
    }
  }
 
  removeDuplicatesFromInfoUser() {
    this.info_user = this.info_user.filter(
      (infoRecord: { controller_uuid: any }) => {
        // Check if the current info_record is not in critical_user
        return !this.critical_user.some(
          (criticalRecord: { controller_uuid: any }) =>
            criticalRecord.controller_uuid === infoRecord.controller_uuid
        );
      }
    );
  }
  pageChanged(event: any) {
    this.currentPage = event;
  }
 
  get paginatedInfo() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    if (this.controller_specific_info) {
    return this.controller_specific_info.slice(startIndex, endIndex);
    }
    return 0;
  }
  view_selector(view_type: any) {
    if (view_type) {
      this.storage.saveToLocalStorage('view_type', view_type);
    }
    return true;
  }
 
  get_view_selected() {
    const selected_view = this.storage.getFromLocalStorage('view_type');
    if (selected_view == null) {
      return 'Grid view';
    }
    return selected_view;
  }
 
  get_view() {
    const view = this.storage.getFromLocalStorage('view_type');
    if (view == 'Table view') {
      return false;
    }
    return true;
  }
 
  getUserType(controller_uuid: any) {
    const user_type = this.storage.getFromLocalStorage(
      controller_uuid + '_type'
    );
    if (user_type) {
      return user_type;
    } else {
      return false;
    }
  }
 
  private listenMqttMessages(): void {
    this.commonService.subscribeMqttMessages('DashboardComponent',(message) => {
      /// can't set this as .subscribe(this.onMqttMessageReceived) - It will act as closure and  this keyword acts as onMqttMessageReceived function on onMqttMessageReceived function
      this.onMqttMessageReceived(message);
    });
  }
 
  private onMqttMessageReceived(message: EmqxRecieveMessageModel) {
    if (message.payload) {
      if (message.payload.has('sensor_telemetry')) {
        this.onSensorTelemetryReceived(message.payload.get('sensor_telemetry'));
      } else if (message.payload.has('controller_status')) {
        this.onControllerStatusReceived(
          message.payload.get('controller_status')
        );
      }
    }
  }
 
  /// Please create a model for this data
  private onSensorTelemetryReceived(data: any): void {
    for (const record of data) {
      if (
        record.measurement == 'SaltChlorinator' ||
        record.measurement == 'DosingPump'
      ) {
        const fields = record.fields;
        const controller_uuid = record.tags.controller_id;
        this.telemetry_processor(fields, controller_uuid);
      }
    }
  }
 
  /// Please create a model for this data
  private onControllerStatusReceived(data: any): void {
    this.storage.saveToLocalStorage(
      data.controller_uuid,
      data.controller_status
    );
  }
 
  telemetry_processor(fields: any, controller_uuid: any) {
    const validFields = ['orp', 'ph', 'temperature', 'set_orp', 'set_ph', 'ph_concentration'];
    for (const fieldName in fields) {
      if (
        validFields.includes(fieldName)
      ) {
        const valueToStore = parseFloat(fields[fieldName]).toFixed(fieldName === 'ph' ? 2 : 1);
        this.storage.saveToLocalStorage(
          controller_uuid + '_' + fieldName,
          valueToStore
        );
        this.getUserSpecificInfo();
        this.get_controller_specific_qr_code();
      }
    }
  }
 
  doPublish(controller_uuid: string) {
    this.commonService.sendMqttMessage(controller_uuid, '{ "msg": "status" }');
  }
 
  search(input: any) {
    if (input) {
      this.controller_specific_info = this.filterObject.transform(
        this.controller_specific_info,
        this.searchTerm
      );
    }
    return false;
  }
  onInput() {
    this.getUserSpecificInfo();
    this.search(this.searchTerm);
  }
 
  save_alert_code(controller_uuid: any, alert_codes: any) {
    if (controller_uuid && alert_codes) {
      for (const key in alert_codes) {
        if (alert_codes.hasOwnProperty(key)) {
          const alert = alert_codes[key].alerts;
          this.save_alert_processor(alert);
        }
      }
      this.storage.saveToLocalStorage(
        controller_uuid + '_alert',
        this.alert_list
      );
    }
    this.alert_list = [];
  }
 
  save_alert_processor(alert: { [x: string]: any }) {
    for (const key in alert) {
      const sub_alert_array = alert[key];
      if (!this.alert_list.includes(sub_alert_array.alert_code)) {
        this.alert_list.push(sub_alert_array.alert_code);
      }
    }
  }
 
 
  get_alert_code(controller_uuid: any) {
    if (controller_uuid) {
      const alert_code_hover = this.storage.getFromLocalStorage(
        controller_uuid + '_alert'
      );
      return alert_code_hover;
    }
    return false;
  }
 
  noDataCheck() {
    if (
      this.critical_user.length == 0 &&
      this.info_user.length == 0 &&
      this.normal_user.length == 0
    ) {
      return true;
    } else {
      return false;
    }
  }
  // function for full screen and exit full screen
  fullscreen() {
    if (this.isFullscreen) {
      const docWithBrowsersExitFunctions = document as Document & {
        mozCancelFullScreen(): Promise<void>;
        webkitExitFullscreen(): Promise<void>;
        msExitFullscreen(): Promise<void>;
      };
      if (docWithBrowsersExitFunctions.exitFullscreen) {
        docWithBrowsersExitFunctions.exitFullscreen();
      } else if (docWithBrowsersExitFunctions.mozCancelFullScreen) {
        /* Firefox */
        docWithBrowsersExitFunctions.mozCancelFullScreen();
      } else if (docWithBrowsersExitFunctions.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        docWithBrowsersExitFunctions.webkitExitFullscreen();
      } else if (docWithBrowsersExitFunctions.msExitFullscreen) {
        /* IE/Edge */
        docWithBrowsersExitFunctions.msExitFullscreen();
      }
    } else {
      const docElmWithBrowsersFullScreenFunctions =
        document.documentElement as HTMLElement & {
          mozRequestFullScreen(): Promise<void>;
          webkitRequestFullscreen(): Promise<void>;
          msRequestFullscreen(): Promise<void>;
        };
      if (docElmWithBrowsersFullScreenFunctions.requestFullscreen) {
        docElmWithBrowsersFullScreenFunctions.requestFullscreen();
      } else if (docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen) {
        /* Firefox */
        docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen();
      } else if (
        docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen
      ) {
        /* Chrome, Safari and Opera */
        docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen();
      } else if (docElmWithBrowsersFullScreenFunctions.msRequestFullscreen) {
        /* IE/Edge */
        docElmWithBrowsersFullScreenFunctions.msRequestFullscreen();
      }
      docElmWithBrowsersFullScreenFunctions.onfullscreenchange = (event:any) =>{
        this.isFullscreen = !this.isFullscreen
      }
    }
  }
 
 
 
 
  async onCardClick(user: any) {
    if (this.isAdmin){
    this.click = true
    const response = await this.controller.customerAdminAccess({"user_id":user.user_id});
 
    if (response?.success && response.data) {
      const sessionService = this.injector
      .get(AppSessionStorageService)
      sessionService
        ?.setGrantToken(response.data, true);
        sessionService
        ?.setInstallerViewUser(user.user_id);
      this.commonService.subscribeMqttTopic(user?.user_id ?? '');
     const encryptedControllerUuid = this.auth.encryptParams(user.controller_uuid);

      this.router.navigate([
        RouteConstants.ADMIN_CUSTOMER_ROUTES,
      ],
    
      { queryParams:{
          controller: encryptedControllerUuid,
          user_id: this.userId ,
       replaceUrl: true }},
    );
 
    }}
    // Or perform any other action
  }
 
 
 
 
  // function to get current screen mode
  get_current_mode() {
    if (this.isFullscreen) {
      this.itemsPerPage = 10;
      return 'Exit full screen';
    } else {
      this.itemsPerPage = 9;
      return 'Full screen';
    }
  }
 
  get_controller_qr(controller_uuid: any) {
    const qr_code_link = this.storage.getFromLocalStorage(
      controller_uuid + '_qr'
    );
    if (qr_code_link) {
      return qr_code_link;
    }
    return 'Invalid';
  }
}
 
@Pipe({
  name: 'InstallerDashboardUsers',
})
export class InstallerDashboardUsersPipe implements PipeTransform {
  transform(controller_specific_user_info: any[], searchTerm: string): any[] {
    if (!controller_specific_user_info.length || !searchTerm) {
      return controller_specific_user_info;
    }
 
    searchTerm = searchTerm.toLowerCase();
 
    return controller_specific_user_info.filter(
      (controller_specific_user_info) => {
        // Add your filtering logic here
        return (
          controller_specific_user_info.firstname
            .toLowerCase()
            .includes(searchTerm) ||
          controller_specific_user_info.lastname
            .toLowerCase()
            .includes(searchTerm) ||
          controller_specific_user_info.controller_uuid
            .toLowerCase()
            .includes(searchTerm)
          // Add more fields as needed
        );
      }
    );
  }
}
 